export const navigation = {
	header: {
		title: "All categories",
		searchTooltip: "Search categories",
		addCategoryTooltip: "Add category",
		showZeroProductCategoriesTooltip: "Show categories with no products",
		hideZeroProductCategoriesTooltip: "Hide categories with no products",
		showEmptyCategories: "Show categories with no products",
		hideEmptyCategories: "Hide categories with no products",
		show: "Show",
		hide: "Hide",
	},
	search: {
		placeholder: "Search category",
		closeTooltip: "Close search",
	},
	subcategories: {
		levelPrefix: "Priority",
	},
	priorityLabel: "Priority",
	categoryDisabledTooltip: "Cannot add products to this category",
	loadingCategories: "Loading categories",
	emptyState: {
		noSearchResults: {
			title: "No categories found",
			message: "We didn't find categories that match your search for",
		},
		noCategories: {
			title: "No categories found",
			message:
				"You don't have product categories yet. Create your first category to organize your products.",
		},
		noCategoriesWithFilters: {
			title: "Categories are hidden",
			message:
				"No categories match your current filters. Click to show all categories or remove filters.",
		},
		clearSearchButton: "Clear search",
		createCategoryButton: "Create category",
		showHiddenCategoriesButton: "Show categories",
	},
};
